import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import MaintenanceRequestList from "@/components/maintenance-requests/maintenance-request-list.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'maintenance-requests-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * Whether modal called from notification popup.
   * @type {boolean}
   * @required
   */
  fromNotificationPopup: {
    type: Boolean,
    required: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const reloadMaintenanceRequest = ref(Date.now());

watch(
  () => showModal.value,
  async () => {
    if (showModal.value) {
      reloadMaintenanceRequest.value = Date.now();
    }
  },
);

const modalClosed = () => {
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    title: "Process Maintenance Requests",
    width: _unref(ModalWidth).XLarge,
    height: "700",
    onModalClosed: modalClosed
  }, {
    content: _withCtx(() => [
      _createVNode(MaintenanceRequestList, {
        isFromOpenModal: true,
        forceReload: reloadMaintenanceRequest.value,
        "grid-height": '58vh',
        fromNotificationPopup: __props.fromNotificationPopup
      }, null, 8, ["forceReload", "fromNotificationPopup"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})